<template>
  <section>
    <div>
      <div class="table_top_div" style="margin-bottom: 5px">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <span style="font-size: 18px; font-weight: bold; display: inline-block; color: #6170d7">
            {{ list_details.hospitalName }}
          </span>
        </div>
      </div>
      <div class="table_top_div" style="margin-bottom: 5px">
        <!-- <div
          type="primary"
          @click="dialogVisible = true"
          style="
            color: #6170d7;
            width: 100%;
            font-size: 16px;
            padding: 5px 0 !important;
            margin-bottom: 25px;
            background-color: white;
            text-align: center;
            box-sizing: border-box;
            border: #6170d7 2px dashed;
            border-radius: 8px;
          "
        >
          <span style="font-size: 20px">+</span>
          添加上报产品
        </div> -->
        <el-table
          :data="list_details.details"
          :border="true"
          :cell-style="cellStyle"
          cell-class-name="cell_class_name"
          max-height="100%"
          header-cell-class-name="header_cell_name"
          highlight-current-row
          v-loading="listLoading"
          style="width: 100%"
        >
          <!-- <el-table-column prop="category" label="Category" width></el-table-column> -->
          <el-table-column prop="productSKU" label="产品编码" width></el-table-column>
          <el-table-column prop="indicatorQuota" label="每日指标" width></el-table-column>
          <el-table-column prop="mtdQuota" label="MTD数量" width></el-table-column>
          <el-table-column prop="quota" label="上报数量" width>
            <template slot-scope="scope">
              <el-input
                type="number"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                v-model="scope.row.quota"
                class="border_none"
                placeholder="请填写"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" v-preventReClick="3000" @click="save" style="color: white; width: 100%; font-size: 16; margin-top: 20px">
          确认上报
        </el-button>
      </div>
    </div>
    <el-dialog title="请选择产品" :visible.sync="dialogVisible" width="30%">
      <el-select value-key="id" v-model="select_product" style="width: 100%" placeholder="请选择">
        <el-option
          v-if="!item.select_if && item.productSKU != '' && item.productSKU != null && item.productSKU != 'Total:'"
          @click.native="get_product_objec(item)"
          v-for="item in product_list"
          :label="item.productSKU"
          :value="item.productSKU"
        ></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="select_set_table(select_product)">添 加</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '@/../util/date'
import { expend_submitestimate } from '@/api/api'
import { getButtonList } from '@/promissionRouter'
import { quillEditor } from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
import Toolbar from '@/components/Toolbar'
import Approve from '@/components/Approve'

export default {
  components: { Toolbar, quillEditor, Approve },
  data() {
    return {
      list_details_table: [],
      listLoading: false,
      select_product: '',
      dialogVisible: false,
      list_details: {},
      select_row: {},
      table_list: [],
      product_list: [],
    }
  },
  methods: {
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label === '每日指标' || column.label === 'MTD数量') {
        return { backgroundColor: '#f6f9ff' }
      }
    },
    back_url() {
      //   this.$router.replace({ path: this.$route.query.back_url })
      this.$router.go(-1)
    },
    async save(res) {
      //   var list = await this.hb_list()
      //   console.log(this.list_details_table)
      //   return
      const { data } = await expend_submitestimate(this.list_details)
      if (data.code == 200) {
        this.$message.success(data.msg)
        this.back_url()
      } else {
        this.$message.error(data.msg)
      }
    },
    hb_list() {
      this.table_list.forEach((item) => {
        let index = this.list_details.details.findIndex((e) => e.productId == item.productId)
        this.list_details.details[index] = item
      })
      return this.list_details
    },
    get_product_objec(row) {
      this.select_row = row
    },
    select_set_table() {
      this.select_row.select_if = true
      this.table_list.push(this.select_row)
      this.select_product = ''
      this.dialogVisible = false
    },
    list_details_fn() {
      var list = this.list_details.details
      list.filter((item) => {
        console.log(item)
        if (item.quota) {
          this.table_list.push(item)
        } else {
          this.product_list.push(item)
        }
      })
    },
  },
  mounted() {
    var hco_list = JSON.parse(localStorage.getItem('hco_list'))
    console.log(hco_list)
    this.list_details = hco_list
    this.list_details_table = hco_list.details
    this.list_details_fn()
  },
}
</script>

<style>
.el-collapse-item__header {
  font-size: 14px !important;
  font-weight: bold !important;
  padding-left: 5px !important;
}
.cell_class_name {
  text-align: center !important;
}
.hidden_row {
  display: none !important;
}
</style>
